export default "__VITE_ASSET__BATO18ZR__"